export const useFormats = () => {
    // TODO 
    return {
        numberFormat0Digits: new Intl.NumberFormat('de', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        numberFormat1Digit: new Intl.NumberFormat('de', { minimumFractionDigits: 1, maximumFractionDigits: 1 }),
        numberFormat2Digits: new Intl.NumberFormat('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    };
}
